var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/24/Mic@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/24/Mic",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(4, 1)",
    stroke: "#000000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 18.3333333,
    x2: 8,
    y2: 22,
    id: "Path"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 3.5,
    y: 0,
    width: 9,
    height: 14.9111111,
    rx: 3.91111111
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,8.8 L0,11 C0,15.0500882 3.35786438,18.3333333 7.5,18.3333333 L8.5,18.3333333 C12.6421356,18.3333333 16,15.0500882 16,11 L16,8.8",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.1c6f68ae62567ea5fa6b2849fe8e6d0f.svg";
export { ForwardRef as ReactComponent };